import { ReactElement } from "react";

import "./EditInformation.scss";

interface IEditInformationProps {
  icon?: ReactElement;
  text?: ReactElement;
  actionButton?: ReactElement;
}

const EditInformation = (props: IEditInformationProps) => {
  const { icon, text, actionButton } = props;

  return (
    <div className="edit-information">
      <div className="edit-information-icon">{icon}</div>
      <div className="edit-information-text">{text}</div>
      <div className="edit-information-action">{actionButton}</div>
    </div>
  );
};

export default EditInformation;
